import { Input, Output, EventEmitter, Component } from "@angular/core";
import { Product } from "../../../Model/Catalog/product";
import { ModelService } from "../../../Services/model.service";
import { ValidationService } from "../../../Services/Validation/validation.service";
import { fieldNames } from "../../../Model/FieldNames";

@Component({
  selector: "electronicSales",
  templateUrl: "electronicSales.component.html",
  styleUrls: ["electronicSales.component.css", "../template.css"]
})
export class ElectronicSalesComponent {
  @Input() model: Product = new Product();
  @Input() showLinkButtons: Boolean = false;
  @Input() templateView: Boolean = false;
  @Output() onValueChanged = new EventEmitter<any>();

  marketingMap = new Map([
    [fieldNames.electronicSalesDescriptionMarketing, 'descriptionMarketing'],
    [fieldNames.electronicSalesPromoInfo, 'promoInfo'],
    [fieldNames.electronicSalesNoteCustomer, 'noteCustomer'],
  ]);

  classificationMap = new Map([
    [fieldNames.electronicSalesFSK, 'fsk'],
    [fieldNames.electronicSalesEUDataSheet, 'euDataSheet'],
    [fieldNames.electronicSalesEEK, 'eek'],
    [fieldNames.electronicSalesEELabel, 'eeLabel'],
    [fieldNames.electronicSalesEEKColor, 'eekColor'],
  ]);

  logisticsMap = new Map([
    [fieldNames.electronicSalesStockQuantitySupplier, 'stockQuantitySupplier'],
    [fieldNames.electronicSalesStockQuantityReseller, 'stockQuantityReseller'],
    [fieldNames.electronicSalesStockKeeping, 'stockKeeping'],
    [fieldNames.electronicSalesStockLocation, 'stockLocation'],
    [fieldNames.electronicSalesStockUnit, 'stockUnit'],
    [fieldNames.electronicSalesStockInfoText, 'stockInfoText'],
    [fieldNames.electronicSalesStockKeepingModus, 'stockKeepingModus'],
    [fieldNames.electronicSalesStockPriceFactor, 'stockPriceFactor'],
    [fieldNames.electronicSalesNoStockInfoText, 'noStockInfoText'],
  ]);

  chargesMap = new Map([
    [fieldNames.electronicSalesSurCharges1ArtNr, 'surCharges1ArtNr'],
    [fieldNames.electronicSalesSurCharges1Percent, 'surCharges1Percent'],
    [fieldNames.electronicSalesSurCharges1FixValue, 'surCharges1FixValue'],
    [fieldNames.electronicSalesSurCharges2ArtNr, 'surCharges2ArtNr'],
    [fieldNames.electronicSalesSurCharges2Percent, 'surCharges2Percent'],
    [fieldNames.electronicSalesSurCharges2FixValue, 'surCharges2FixValue'],
    [fieldNames.electronicSalesCharges, 'charges'],
  ]);

  ordersMap = new Map([
    [fieldNames.electronicSalesOrderFactor, 'orderFactor'],
    [fieldNames.electronicSalesOrderStockFactor, 'orderStockFactor'],
    [fieldNames.electronicSalesOrderPriceFactor, 'orderPriceFactor'],
  ]);

  othersMap = new Map([
    [fieldNames.electronicSalesShowParts, 'showParts'],
    [fieldNames.electronicSalesOptionTypeId, 'optionTypeId'],
    [fieldNames.electronicSalesAlternateArticleNumber, 'alternateArticleNumber'],
  ]);

  private _showHTMLEditor: Boolean = true;

  get showHTMLEditor() {
    return this._showHTMLEditor;
  }

  set showHTMLEditor(value) {
    this._showHTMLEditor = value;
  }

  constructor(public modelService: ModelService, public validationService: ValidationService) {
  }

  update(event = null, field?: string, system: string = '-1', element: string = '-1') {
    if (event) {
      event.dField = field;
      event.dSystem = system;
      event.dElement = element;
      event.createTemplateItem = true;
    }
    this.onValueChanged.emit(event);
  }
}
